import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { TruncatePipe } from 'src/app/pipe/truncate.pipe';
import { authService } from 'src/app/services/auth.service';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-image-section',
  standalone: true,
  imports: [CommonModule, MatIconModule, TruncatePipe],
  template: `
    <div class="image-section" (click)="openFile(doc.cloud_key)">
      <ng-container [ngSwitch]="doc.type">
        <!-- Display image if the file type is an image -->
        <img
          *ngSwitchCase="'image'"
          [src]="doc.signUrlThumb"
          alt="Thumbnail"
        />

        <!-- Display PDF icon if the file type is PDF -->
        <mat-icon *ngSwitchCase="'pdf'" class="pdf-icon">
          picture_as_pdf
        </mat-icon>

        <!-- Display Excel icon if the file type is Excel -->
        <mat-icon *ngSwitchCase="'excel'" class="excel-icon">
          insert_drive_file
        </mat-icon>

        <!-- Display a default icon for other file types -->
        <mat-icon *ngSwitchDefault>insert_drive_file</mat-icon>
      </ng-container>

      <!-- Display a link to the file if it's not an image -->
      <a style="cursor: pointer;">
        {{ doc.name | truncate:20 }}
      </a>
    </div>
  `,
  styles: [
    `
      .image-section {
        display: flex;
        flex-direction: column;
        align-items: center;
        min-width: 30%;
        cursor:pointer
      }

      img {
        max-width: 100px;
        max-height: 100px;
        border-radius: 4px;
      }

      a {
        color: var(--lead-text-primary, var(--text-primary, #000));
        text-decoration: none;
        margin-top: 5px;
      }

      .pdf-icon {
        color: red;
        font-size: 50px;
        width: 50px;
        height: 50px;
      }

      .excel-icon {
        color: green;
        font-size: 50px;
        width: 50px;
        height: 50px;
      }
    `,
  ],
})
export class ImageSectionComponent {
    constructor(private authService:authService){}
  // The document object should contain properties like fileType, cloud_key, path_url, and name.
  @Input() doc: any;
  
  async openFile(key) {
    const newKey = `documents/${key}`
    const response:any = await firstValueFrom(this.authService.getSignUrl(newKey,'500'))
    window.open(response.signUrl, '_blank');
  }
}
